import React, { useState } from 'react'
import { Select } from 'components/select'
import Flatpickr from 'react-flatpickr'
import moment from 'moment'

export const DATE_RANGES = {
    TODAY: 'TODAY',
    YESTERDAY: 'YESTERDAY',
    LAST_7_DAYS: 'LAST_7_DAYS',
    LAST_WEEK: 'LAST_WEEK',
    LAST_30_DAYS: 'LAST_30_DAYS',
    THIS_MONTH_TO_DATE: 'THIS_MONTH_TO_DATE',
    LAST_MONTH: 'LAST_MONTH',
    LAST_QUARTER: 'LAST_QUARTER',
    THIS_YEAR_TO_DATE: 'THIS_YEAR_TO_DATE',
    LAST_YEAR: 'LAST_YEAR',
    CUSTOM_RANGE: 'CUSTOM_RANGE',
}

export const DateFilter = ({ onDateChange }) => {
    const [selectedRange, setSelectedRange] = useState(DATE_RANGES.TODAY)
    const [customDateRange, setCustomDateRange] = useState([])

    const handleRangeChange = range => {
        setSelectedRange(range)
        if (range !== DATE_RANGES.CUSTOM_RANGE) {
            // const dateRange = getDateRangeValues(range)
            onDateChange({
                type: range,
                from: null,
                to: null,
            })
        }
    }

    const handleCustomDateChange = dates => {
        if (dates.length === 2) {
            setCustomDateRange(dates)
            onDateChange({
                type: DATE_RANGES.CUSTOM_RANGE,
                from: moment(dates[0]).format('YYYY-MM-DD'),
                to: moment(dates[1]).format('YYYY-MM-DD'),
            })
        }
    }

    return (
        <div className="flex gap-4 items-end">
            <div className="w-[200px]">
                <Select value={selectedRange} onChange={e => handleRangeChange(e.target.value)} className="w-full">
                    <option value={DATE_RANGES.TODAY}>Today</option>
                    <option value={DATE_RANGES.YESTERDAY}>Yesterday</option>
                    <option value={DATE_RANGES.LAST_7_DAYS}>Last 7 Days</option>
                    <option value={DATE_RANGES.LAST_WEEK}>Last Week</option>
                    <option value={DATE_RANGES.LAST_30_DAYS}>Last 30 Days</option>
                    <option value={DATE_RANGES.THIS_MONTH_TO_DATE}>This Month to Date</option>
                    <option value={DATE_RANGES.LAST_MONTH}>Last Month</option>
                    <option value={DATE_RANGES.LAST_QUARTER}>Last Quarter</option>
                    <option value={DATE_RANGES.THIS_YEAR_TO_DATE}>This Year to Date</option>
                    <option value={DATE_RANGES.LAST_YEAR}>Last Year</option>
                    <option value={DATE_RANGES.CUSTOM_RANGE}>Custom Range</option>
                </Select>
            </div>
            {selectedRange === DATE_RANGES.CUSTOM_RANGE && (
                <div className="w-[200px]">
                    <Flatpickr
                        options={{
                            mode: 'range',
                            dateFormat: 'Y-m-d',
                            maxDate: 'today',
                        }}
                        value={customDateRange}
                        onChange={handleCustomDateChange}
                        placeholder="Select date range"
                        className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                    />
                </div>
            )}
        </div>
    )
}
